export default "__VITE_PUBLIC_ASSET__4d61e18d__"